import { RichText } from "@components/cms/rich-text-renderer/RichText";
import type { Document } from "@contentful/rich-text-types";
import { Text } from "@ui/components/content/text/Text";
import { Checkbox } from "@ui/components/forms/checkbox/Checkbox";
import { FormControl } from "@ui/components/forms/form-control/FormControl";
import { FormErrorMessage } from "@ui/components/forms/form-control/FormError";
import { FormLabel } from "@ui/components/forms/form-control/FormLabel";
import { Box } from "@ui/components/layout/box/Box";
import { Flex } from "@ui/components/layout/flex/Flex";
import { useField } from "formik";
import { useMemo } from "react";
import { styles } from "./PolicyAgreement.style";

type Props = {
    error: string;
    touched: boolean;
    policyAgreement: Document;
    discountDisclaimer?: string;
    checkboxText?: string;
};

export const PolicyAgreement = ({
    checkboxText,
    error,
    touched,
    policyAgreement,
    discountDisclaimer,
}: Props) => {
    const renderedPolicyText = useMemo(
        () => <RichText data={policyAgreement} />,
        [policyAgreement]
    );
    const [field] = useField({ name: "policy", type: "checkbox" });

    if (!policyAgreement) return null;

    return (
        <FormControl isRequired isInvalid={!!error && touched}>
            <Flex {...styles.flex}>
                <Box>
                    <Checkbox
                        {...field}
                        id="policy"
                        aria-labelledby="policyLabel"
                        aria-describedby="policyDescription"
                        {...styles.policyCheckBox}
                    />
                </Box>
                <FormLabel id="policyLabel" htmlFor="policy" {...styles.policyLabel}>
                    * {checkboxText ?? renderedPolicyText}
                </FormLabel>
            </Flex>
            <Box {...styles.errorBox}>
                <FormErrorMessage {...styles.errorMessage}>{error}</FormErrorMessage>
            </Box>
            {checkboxText && <Box {...styles.text}>{renderedPolicyText}</Box>}
            {discountDisclaimer && <Text {...styles.text}>{discountDisclaimer}</Text>}
        </FormControl>
    );
};
